import { fetchGoldKlineData } from "@/utils/use-gold-data";
import { marketList } from "@/utils/use-marketlist-data";
import { CandleType, dispose, init, LineType } from "klinecharts";
import { useContext, useEffect, useMemo, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { huobiApi } from "../../../../api/huobi";
import { setIsShowOrderSignal } from "../../../../pages/trade";
import { WSContext, WSMinContext } from "../../../../router/router";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function MyChartComponent({
  nowTab,
  setIndex,
  setType,
  timeindex,
  settimeindex,
  ctmarketlist,
}) {
  // console.log('faith=============setTypesetTypesetType', timeindex)
  const [coinListData, setCoinListData] = useContext(WSContext);
  const [coinListMinData, _] = useContext(WSMinContext);
  const { t: translate } = useTranslation();
  const [kLineDatas, setkLineDatas] = useState([] as any[]);
  const [kchart, setkchart] = useState<any>();

  const isGold = useMemo(() => {
    if (marketList.value.length === 0) {
      return false;
    }

    return (
      marketList.value.find((item) => item.coinname === nowTab)?.coinType !== 1
    );
  }, [nowTab]);

  const klinePeriod = [
    { multiplier: 1, timespan: "minute" },
    { multiplier: 1, timespan: "minute" },
    { multiplier: 5, timespan: "minute" },
    { multiplier: 15, timespan: "minute" },
    { multiplier: 30, timespan: "minute" },
    { multiplier: 1, timespan: "hour" },
    { multiplier: 1, timespan: "day" },
    { multiplier: 1, timespan: "week" },
  ];

  // console.log('faith=============ctmarketlist', ctmarketlist)

  const adjustTimestamp = (timestamp) => {
    const currentTime = new Date().getTime();
    const adjustedTime = timestamp * 1000 + 24 * 60 * 60 * 1000;
    return adjustedTime <= currentTime ? adjustedTime : null;
  };

  //获取历史
  const getHistoryKLineData = async (symbol, period) => {
    if (isGold) {
      const kLineData = await fetchGoldKlineData(
        nowTab.toUpperCase(),
        timeindex
      );
      setkLineDatas(kLineData);

      return kLineData;
    }
    const baseUrl = "https://api.huobi.pro";
    const huobiPeriod = mapPeriodToHuobi(period);
    const data = await huobiApi.getHistoryK(
      symbol.ticker.toLowerCase(),
      huobiPeriod,
      2000
    );
    console.log(4555, data);

    let type = 1; // 默认值为1
    const currentSymbol = symbol.ticker.toLowerCase();

    // 遍历ctmarketlist查找匹配的symbol
    if (Array.isArray(ctmarketlist)) {
      const matchedItem = ctmarketlist.find(
        (item) => item.symbol === currentSymbol
      );
      if (matchedItem) {
        type = matchedItem.type;
      }
    }

    let kLineData;

    if (type == 2) {
      // 如果type为2，使用新逻辑（带时间调整和过滤的逻辑）
      kLineData = data.data
        .map((item) => {
          const adjustedTime = adjustTimestamp(item.id);
          if (adjustedTime === null) return null;
          return {
            timestamp: adjustedTime,
            open: item.open,
            close: item.close,
            high: item.high,
            low: item.low,
            volume: item.vol,
          };
        })
        .filter((item) => item !== null);
    } else {
      // 如果type不为2，使用原来的逻辑
      kLineData =
        data?.data?.map((item) => ({
          timestamp: item.id * 1000,
          open: item.open,
          close: item.close,
          high: item.high,
          low: item.low,
          volume: item.vol,
        })) ?? [];
    }

    kLineData = kLineData.reverse();

    setkLineDatas(kLineData);
    return kLineData;
  };

  // 将自定义周期映射到火币支持的周期
  const mapPeriodToHuobi = (period) => {
    // 假设我们基于 timespan 属性来进行映射
    switch (period.timespan) {
      case "minute":
        // 假设 multiplier 为 1 时映射为 '1min', 为 5 时映射为 '5min'
        return `${period.multiplier}min`;
      case "hour":
        // 假设 multiplier 为 1 时映射为 '60min'（火币没有小时表示，所以用分钟表示）
        return `${period.multiplier * 60}min`;
      case "day":
        // 假设 multiplier 为 1 时映射为 '1day'
        return `${period.multiplier}day`;
      case "week":
        return `${period.multiplier}week`;
      // 添加更多映射规则...
      default:
        return "1min"; // 默认值
    }
  };

  //初始化图标
  const initChart = async () => {
    if (kchart) {
      dispose("k-line-chart");
    }
    const chart = init("k-line-chart");
    setkchart(chart);
    chart.setStyles({
      grid: {
        horizontal: {
          size: 0.1,
          style: "solid" as LineType,
        },
        vertical: {
          size: 0.1,
          style: "solid" as LineType,
        },
      },
      candle: {
        type:
          timeindex == 1
            ? ("area" as CandleType)
            : ("candle_solid" as CandleType),
        area: {
          lineSize: 1,
        },
        // @ts-ignore
        point: {
          show: false,
        },
        tooltip: {
          text: {
            size: 10,
          },
          //清空头部
          custom: [],
        },
      },
      indicator: {
        tooltip: {
          // showType: "rect",
          text: {
            size: 9,
          },
        },
      },
      yAxis: {
        // position: "left",
        axisLine: {
          size: 1,
          color: "#3E444D",
        },
      },
      xAxis: {
        axisLine: {
          size: 1,
          color: "#3E444D",
        },
      },
      separator: {
        size: 1,
        color: "#3E444D",
      },
    });
    chart.setOffsetRightDistance(0);
    chart.setTimezone("Europe/Berlin");
    chart.createIndicator("MA", true, { id: "candle_pane" });
    chart.createIndicator("VOL");
    chart.createIndicator("MACD");

    const data = await getHistoryKLineData(
      {
        ticker: `${nowTab.toUpperCase()}USDT`,
        name: `${nowTab.toUpperCase()}USDT`,
      },
      klinePeriod[timeindex - 1]
    );
    chart.applyNewData(data);
  };
  //监控变化
  useEffect(() => {
    const item = coinListData[nowTab];
    const item1 = coinListMinData[nowTab];
    if (kchart && item && item1) {
      kchart.updateData({
        timestamp: item1.id * 1000,
        open: item1.open,
        close: item.close,
        high: item1.high,
        low: item1.low,
        volume: item1.vol,
      });
    }
  }, [coinListMinData[nowTab]?.close, coinListData[nowTab]?.close]);
  useEffect(() => {
    initChart();
  }, [timeindex, nowTab]);
  // useEffect(() => {
  //   initChart()
  // }, [])

  return (
    <div>
      <div id="k-line-chart" style={{ height: "580px", width: "100%" }}></div>
      <div
        style={{
          height: "70px",
        }}
      ></div>
      {/* 底部按钮 */}
      {isMobile && (
        <div className="p-0 btn-footer1-1 bg-neutral-900">
          <div className="btn-footer1-2">
            <button
              className="btn-footer1-3 mx-0 flex-1 rounded-none"
              onClick={() => {
                setIndex(3);
                setType(1);
                setIsShowOrderSignal.value(true);
              }}
            >
              {translate(getText("看漲"))}
            </button>
            <button
              className="btn-footer1-4 mx-0 flex-1 rounded-none"
              onClick={() => {
                setIndex(3);
                setType(2);
                setIsShowOrderSignal.value(true);
              }}
            >
              {translate(getText("看跌"))}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
